<template>
    <el-dialog
            :title="dataForm.id?'编辑':'新增'"
            :visible.sync="visible"
            :append-to-body="true"
            width="600px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px">
            <el-form-item label="客户姓名" prop="cusName">
                <el-input type="text" v-model="dataForm.cusName" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="cusMobile">
                <el-input type="text" v-model="dataForm.cusMobile" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="小区" prop="cusHouse">
                <el-input type="text" v-model="dataForm.cusHouse" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="户型" prop="cusApartment">
                <el-input type="text" v-model="dataForm.cusApartment" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="业务员" prop="userId">
                <el-select v-model="dataForm.userId" filterable placeholder="请选择" clearable>
                    <el-option
                            v-for="item in userList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        <span style="float: left">
                                {{ item.label }}
                                <span style="color: #8492a6; font-size: 12px;">（{{item.isWork ? '离职' : '在职'}}）</span>
                            </span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设计师" prop="designId">
                <el-select v-model="dataForm.designId" filterable placeholder="请选择" clearable>
                    <el-option
                            v-for="item in designList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        <span style="float: left">
                                {{ item.label }}
                                <span style="color: #8492a6; font-size: 12px;">（{{item.isWork ? '离职' : '在职'}}）</span>
                            </span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客户情况" prop="state">
                <el-radio-group v-model="dataForm.state" size="small">
                    <el-radio :label="1" border>意向</el-radio>
                    <el-radio :label="2" border>订单</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="意向" prop="intention" v-if="dataForm.state===1">
                <el-radio-group v-model="dataForm.intention">
                    <el-radio :label="1">A+</el-radio>
                    <el-radio :label="2">A</el-radio>
                    <el-radio :label="3">B</el-radio>
                    <el-radio :label="4">C</el-radio>
                    <el-radio :label="5">未成交</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="订单" prop="orderPrice" v-if="dataForm.state===2">
                <el-radio-group v-model="dataForm.orderPrice">
                    <el-radio :label="1">意向金</el-radio>
                    <el-radio :label="2">定金20000</el-radio>
                    <el-radio :label="3">货款80%</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="风格喜好" prop="styleLike">
                <el-input type="text" v-model="dataForm.styleLike" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="需求备注" prop="remark">
                <el-input type="textarea" :rows="5" v-model="dataForm.remark" style="width: 80%;" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">保存</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {Invite} from "../../api/invite";
    import {UdUser} from "../../api/udUser";

    export default {
        name: "invite-add-or-update",
        data() {
            let validateMobile = (rule, value, callback) => {
                let reg = /^\d{7,11}$/;
                if (!reg.test(value)) {
                    callback(new Error('请输入7-11位的数字！'))
                } else {
                    callback()
                }
            };
            return {
                visible: false,
                userList: [],
                designList: [],
                dataForm: {
                    id: 0,
                    cusName: '',
                    userId: '',
                    designId: '',
                    cusMobile: '',
                    cusHouse: '',
                    cusApartment: '',
                    styleLike: '',
                    remark: '',
                    state: 1,
                    intention: 1,
                    orderPrice: 1
                },
                dataRule: {
                    cusName: [
                        {required: true, message: '客户姓名不能为空', trigger: 'blur'}
                    ],
                    userId: [
                        {required: true, message: '请选择业务员！', trigger: 'blur'}
                    ],
                    cusMobile: [
                        {required: true, message: '手机号码不能为空', trigger: 'blur'},
                        {validator: validateMobile, trigger: 'blur'}
                    ],
                    cusHouse: [
                        {required: true, message: '小区不能为空', trigger: 'blur'}
                    ],
                    cusApartment: [
                        {required: true, message: '户型不能为空', trigger: 'blur'}
                    ],
                    styleLike: [
                        {required: true, message: '风格喜好不能为空', trigger: 'blur'}
                    ]
                }
            }
        },

        watch: {
            //弹出层关闭清空数据
            visible(newValue, oldValue) {
                if (newValue === false) {
                    this.$nextTick(() => {
                        this.$refs['dataForm'].resetFields()
                    });
                }
            }
        },

        methods: {
            getUserList() {
                UdUser.getUserList().then(res => {
                    if (res.code === 0) {
                        let userList = res.userList;
                        this.userList = [];
                        this.designList = [];
                        userList.forEach((item, index) => {
                            if (item.deparment === 7) { // 获取销售部人员
                                this.userList.push(item);
                            }
                            if (item.deparment === 6) { // 获取设计师
                                this.designList.push(item);
                            }
                        });
                    }
                })
            },
            init(id) {
                this.visible = true;
                this.dataForm.id = id;
                this.getUserList();
                if (this.dataForm.id) {
                    Invite.getInviteInfo(this.dataForm.id).then(res => {
                        if (res.code === 0) {
                            this.dataForm.cusName = res.invite.cusName;
                            this.dataForm.userId = res.invite.userId;
                            this.dataForm.designId = res.invite.designId;
                            this.dataForm.cusMobile = res.invite.cusMobile;
                            this.dataForm.cusHouse = res.invite.cusHouse;
                            this.dataForm.cusApartment = res.invite.cusApartment;
                            this.dataForm.styleLike = res.invite.styleLike;
                            this.dataForm.remark = res.invite.remark;
                            this.dataForm.state = res.invite.state;
                            this.dataForm.intention = res.invite.intention;
                            this.dataForm.orderPrice = res.invite.orderPrice;
                        }
                    })
                }
            },
            /**
             * 提交
             */
            dataFormSubmit() {
                let datas = {
                    'id': this.dataForm.id,
                    'cusName': this.dataForm.cusName,
                    'userId': this.dataForm.userId,
                    'designId': this.dataForm.designId,
                    'cusMobile': this.dataForm.cusMobile,
                    'cusHouse': this.dataForm.cusHouse,
                    'cusApartment': this.dataForm.cusApartment,
                    'styleLike': this.dataForm.styleLike,
                    'remark': this.dataForm.remark,
                    'state': this.dataForm.state,
                    'intention': this.dataForm.state === 1 ? this.dataForm.intention : 6,
                    'orderPrice': this.dataForm.state === 2 ? this.dataForm.orderPrice : 4
                };
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let type = this.dataForm.id ? 'update' : 'save';
                        Invite.addOrUpdateInvite(type, datas).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$nextTick(() => {
                                            this.$emit('getDataList');
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }
                });
            }
        }

    }
</script>

<style scoped>

</style>
